export const fmtAUD = (n) =>
    new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(n) || 0);

export const fmtDate = (iso) => {
    if (!iso) return '';
    try { return new Date(iso).toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' }); }
    catch { return iso; }
};

export const CATEGORIES = [
    { slug: 'gi-adults', label: 'Gi — Adults' },
    { slug: 'gi-kids', label: 'Gi — Kids' },
    { slug: 'rashguard-ss', label: 'Rashguard — Short Sleeve' },
    { slug: 'rashguard-ls', label: 'Rashguard — Long Sleeve' },
    { slug: 'belts', label: 'Rank Belts' },
    { slug: 'tshirts', label: 'T-Shirts' },
    { slug: 'mats', label: 'Tatami Mats' },
];

export const BELT_SWATCHES = [
    { name: 'White', hex: '#FFFFFF' },
    { name: 'Grey / White', hex: 'linear-gradient(90deg,#D4D4D8 50%,#FFFFFF 50%)' },
    { name: 'Grey', hex: '#A1A1AA' },
    { name: 'Grey / Black', hex: 'linear-gradient(90deg,#A1A1AA 50%,#0a0a0a 50%)' },
    { name: 'Yellow / White', hex: 'linear-gradient(90deg,#FACC15 50%,#FFFFFF 50%)' },
    { name: 'Yellow', hex: '#FACC15' },
    { name: 'Yellow / Black', hex: 'linear-gradient(90deg,#FACC15 50%,#0a0a0a 50%)' },
    { name: 'Orange / White', hex: 'linear-gradient(90deg,#F97316 50%,#FFFFFF 50%)' },
    { name: 'Orange', hex: '#F97316' },
    { name: 'Orange / Black', hex: 'linear-gradient(90deg,#F97316 50%,#0a0a0a 50%)' },
    { name: 'Green / White', hex: 'linear-gradient(90deg,#22C55E 50%,#FFFFFF 50%)' },
    { name: 'Green', hex: '#22C55E' },
    { name: 'Blue', hex: '#3B82F6' },
    { name: 'Purple', hex: '#7E22CE' },
    { name: 'Brown', hex: '#78350F' },
    { name: 'Black', hex: '#0a0a0a' },
    { name: 'Red', hex: '#DC2626' },
    { name: 'Coral', hex: '#FB7185' },
];
